// @ts-nocheck
import * as React from "react";

const EmailFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M3 19V5h18v14H3Zm9-6.884L4 6.885V18h16V6.884l-8 5.232ZM12 11l7.692-5H4.308L12 11ZM4 6.885V6v12V6.884Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(EmailFill);
